import React, { useState } from "react";
import { logo } from "../utils";
import { navLists } from "../constants";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="w-full py-3 sm:px-10 px-5 flex justify-between items-center bg-transparent backdrop-blur-xl fixed top-0 left-0 right-0 z-50">
      {/* Left: Logo */}
      <div className="flex items-center">
        <a href="/" className="flex items-center">
          <img src={logo} alt="Logo" width={190} height={24} className="ml-6" />
        </a>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center">
        {navLists.map(({ label, path }) => (
          <a
            key={label}
            href={path}
            className="px-6 cursor-pointer text-white hover:text-gray-300 text-xl transition-all"
          >
            {label}
          </a>
        ))}
        <a
          href="https://www.treatwell.at/ort/oase-salon-massage-kosmetik-fusspflege/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            className="px-[.9rem] py-[.5rem] text-white text-lg font-medium 
              bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-500 
              transition-all duration-300 shadow-lg shadow-green-400/30 hover:shadow-green-700/100
              rounded-xl"
          >
            <p className="text-sm lg:text-xl sm:text-sm whitespace-nowrap">
              Jetzt Buchen
            </p>
          </button>
        </a>
      </nav>

      {/* Mobile Hamburger */}
      <div className="md:hidden">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="focus:outline-none"
          aria-label="Toggle Menu"
        >
          {isOpen ? (
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 8h16M4 16h16"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`bg-black/80 backdrop-blur-md absolute top-full left-0 w-full flex flex-col items-center transition-all duration-300 overflow-hidden md:hidden ${
          isOpen ? "max-h-96 opacity-100 py-4" : "max-h-0 opacity-0 py-0"
        }`}
      >
        {navLists.map(({ label, path }) => (
          <a
            key={label}
            href={path}
            className="py-2 text-white text-xl transition-all"
            onClick={() => setIsOpen(false)}
          >
            {label}
          </a>
        ))}
        <a
          href="https://www.treatwell.at/ort/oase-salon-massage-kosmetik-fusspflege/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setIsOpen(false)}
        >
          <button
            className="mt-2 px-[.9rem] py-[.5rem] text-white text-lg font-medium 
              bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-500 
              transition-all duration-300 shadow-lg shadow-green-400/30 hover:shadow-green-700/100
              rounded-xl"
          >
            <p className="text-sm lg:text-xl sm:text-sm whitespace-nowrap">
              Jetzt Buchen
            </p>
          </button>
        </a>
      </div>
    </header>
  );
};

export default Navbar;
